
import React from 'react'

import { Input, Table } from 'antd'
import useReporteAgrupandoMatematicas from '../hooks/adminexamen/useReporteAgrupandoMatematicas'
import { EmptyPersonalizado } from './EmptyPersonalizado'
import { SearchOutlined } from '@ant-design/icons'
import { buscar_cantidad_aspirantes } from '../functions/arreglos'

const ReporteAgrupandoMatematicas = () => {

    const { datosReporteAlumnosMatematicas, columns, loading, setTextoBuscar, textoBuscar } = useReporteAgrupandoMatematicas()


    var cantidad_aspirantes = buscar_cantidad_aspirantes( datosReporteAlumnosMatematicas )

    return (
        <>
            <Table
                loading={ loading }
                columns={ columns }
                title = { () => (
                    <>
                      <h1>{ cantidad_aspirantes }</h1>
                      <Input size='large' id='inputBuscarEstadoExamen' autoComplete='off' placeholder="Buscar aspirante" allowClear onChange={ e => setTextoBuscar( e.target.value )  } value={ textoBuscar } prefix={ <SearchOutlined /> }/>
                    </>
                )}
                rowKey="pk_aspirante"
                showSorterTooltip={ false }
                dataSource={ datosReporteAlumnosMatematicas }
                locale={{ emptyText: <EmptyPersonalizado/> }}
            />
        </>
    )
}

export default ReporteAgrupandoMatematicas
